import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
export var Slow = /*#__PURE__*/function () {
  function Slow() {
    _classCallCheck(this, Slow);
    this.factor = 3;
    this.radius = 200;
  }
  _createClass(Slow, [{
    key: "active",
    get: function get() {
      return false;
    },
    set: function set(_value) {}
  }, {
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      if (data.factor !== undefined) {
        this.factor = data.factor;
      }
      if (data.radius !== undefined) {
        this.radius = data.radius;
      }
    }
  }]);
  return Slow;
}();